import React from 'react';

/**
 * EmptyState — vista cuando no hay partidos en vivo.
 * Versión minimalista: solo título + radar animado + leyenda.
 */
export default function EmptyState() {
  return (
    <div className="empty-state">
      <div className="empty-grid">
        <div className="empty-left">
          <h2 className="empty-title">
            No hay partidos en vivo<br/>en este momento.
          </h2>
        </div>
        <div className="empty-right">
          <div className="radar">
            <div className="radar-grid" />
            <div className="radar-sweep" />
            <div className="radar-ring r1" />
            <div className="radar-ring r2" />
            <div className="radar-ring r3" />
            <div className="radar-blip b1" />
            <div className="radar-blip b2" />
            <div className="radar-blip b3" />
            <div className="radar-center" />
          </div>
          <div className="radar-legend">
            <span><i className="live-dot" /> Escaneando</span>
            <span className="mono">7s / tick</span>
          </div>
        </div>
      </div>
    </div>
  );
}
